import React from 'react';
import { MinLoader } from '../loader';
import { Colors, FindLoad, Images } from 'utils';
import { SimpleTooltip } from '../tooltip';

export const SelectActions = ({
    selectedList,
    selectAll,
    selectInnetText,
    submitClaims,
    removeSelected,
    actionType,
    disableSubmit,
    toolTitle,
    submitBtnIcon,
    submitText,
    renderOtherBtns,
    noSubmit,
    submitPermission,
    countLabel,
}) => {
    const loader = FindLoad(actionType);
    const checkPermissions = submitPermission !== undefined ? submitPermission : true;
    return (
        <div>
            <div className="select-action-box">
                <div className="select-count-box">
                    <div>{selectedList}</div>
                    <p>{countLabel ? countLabel : 'selected'}</p>
                </div>
                <div className="flex-align-center" style={{ gap: 8 }}>
                    {selectAll && (
                        <button style={{ background: 'transparent' }} className="select-all-btn" onClick={(e) => selectAll(e, '', 'selectAll')}>
                            <img src={Images.selectAll} alt="icon" />
                            <p> {selectInnetText ? selectInnetText : 'Select All'}</p>
                        </button>
                    )}

                    {!noSubmit && checkPermissions && (
                        <>
                            {submitBtnIcon ? (
                                <button className="select-all-btn" onClick={submitClaims}>
                                    {loader?.length ? (
                                        <MinLoader width={'18px'} height={'18px'} margin={'0'} color={'white'} position={'relative'} />
                                    ) : (
                                        <img src={submitBtnIcon} alt="icon" />
                                    )}
                                    {submitText}
                                </button>
                            ) : disableSubmit ? (
                                <SimpleTooltip title={<p>{toolTitle}</p>} placement="top-start">
                                    <button style={{ opacity: 0.5 }} className="select-all-btn">
                                        Submit
                                    </button>
                                </SimpleTooltip>
                            ) : (
                                <button className="select-all-btn" onClick={submitClaims}>
                                    {loader?.length ? (
                                        <MinLoader margin={'0'} color={Colors.BackgroundBlue} position={'relative'} />
                                    ) : submitText ? (
                                        submitText
                                    ) : (
                                        'Submit'
                                    )}
                                </button>
                            )}
                        </>
                    )}
                    {renderOtherBtns}
                </div>
                <button className="close-selected-btn" onClick={removeSelected}>
                    <img src={Images.closeExWhite} alt="close" />
                </button>
            </div>
        </div>
    );
};
